import React from "react";
import { withRouter } from "react-router-dom";
import { postApi } from '../../service/service';
import { API_URL } from '../../config';
import { getToken, getUserRole } from '../../utils/auth';
import { toast } from '../../utils/toast';
import "./style.css";

class CreateUser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      password: '',
      role: 'user',
      isLoading: false,
      errorMsg: ''
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    // Check if user is superadmin
    const role = getUserRole();
    if (role !== 'superadmin') {
      toast.error('Access denied. Only superadmin can create users.');
      this.props.history.push('/');
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
      errorMsg: ''
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const { history } = this.props;
    const token = getToken();
    
    if (!token) {
      toast.error('You must be logged in to perform this action.');
      history.push('/login');
      return;
    }

    const role = getUserRole();
    if (role !== 'superadmin') {
      toast.error('Access denied. Only superadmin can create users.');
      return;
    }

    this.setState({ isLoading: true, errorMsg: '' });

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    };

    const body = {
      name: this.state.name.trim(),
      email: this.state.email.trim().toLowerCase(),
      password: this.state.password,
      role: this.state.role
    };

    postApi(`${API_URL}/api/auth/create-user`, headers, body)
      .then((data) => {
        this.setState({ isLoading: false });
        if (data.status) {
          toast.success(data.message || 'User created successfully!');
          // Reset form
          this.setState({
            name: '',
            email: '',
            password: '',
            role: 'user'
          });
        } else {
          const errorMessage = data.message || data.msg || 'Failed to create user. Please try again.';
          this.setState({ errorMsg: errorMessage });
          toast.error(errorMessage);
        }
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        const errorMessage = error.message || error.msg || 'An error occurred. Please try again.';
        this.setState({ errorMsg: errorMessage });
        toast.error(errorMessage);
        
        if (error.statusCode === 401 || error.statusCode === 403) {
          history.push('/login');
        }
      });
  }

  render() {
    const { name, email, password, role, isLoading, errorMsg } = this.state;
    const displayMsg = errorMsg || 'Please enter user details';

    return (
      <div className='loginContainer'>
        <div className="container">
          <div className="login-form">
            <div className="main-div">
              <div className="panel">
                <p>{displayMsg}</p>
              </div>
              <form id="CreateUser" onSubmit={this.onSubmit}>
                <div className="form-group">
                  <input
                    value={name}
                    onChange={this.handleChange}
                    name="name"
                    type="text"
                    className="form-control"
                    id="inputName"
                    placeholder="Full Name"
                    required
                    minLength="2"
                    maxLength="100"
                  />
                </div>
                <div className="form-group">
                  <input
                    value={email}
                    onChange={this.handleChange}
                    name="email"
                    type="email"
                    className="form-control"
                    id="inputEmail"
                    placeholder="Email Address"
                    required
                  />
                </div>
                <div className="form-group">
                  <input
                    value={password}
                    onChange={this.handleChange}
                    name="password"
                    type="password"
                    className="form-control"
                    id="inputPassword"
                    placeholder="Password (min 8 chars, must include uppercase, lowercase, and number)"
                    required
                    minLength="8"
                  />
                </div>
                <div className="form-group">
                  <select
                    value={role}
                    onChange={this.handleChange}
                    name="role"
                    className="form-control"
                    id="inputRole"
                    required
                    style={{ height: '50px', lineHeight: '50px' }}
                  >
                    <option value="user">User</option>
                    <option value="admin">Admin</option>
                    <option value="superadmin">Super Admin</option>
                  </select>
                </div>
                <button 
                  type="submit" 
                  className="btn btn-primary"
                  disabled={isLoading}
                >
                  {isLoading ? 'Creating...' : 'Create User'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CreateUser);




// WEBPACK FOOTER //
// ./src/components/user/CreateUser.js